import React, { useMemo } from 'react';
import DetailsWidget from '../details-widget';

export const config = {
  totalChecks: (t) => ({
    title: t('Total Checks'),
    content: t('Latest update'),
    tooltip: {
      title: t('Total Checks'),
      body: t('Number of checks facilitated through the Datastake MMT Application'),
    },
    type: 'DEFAULT',
    sort: 1,
  }),
  triangulation: (t) => ({
    title: t('Triangulation'),
    content: t('More than one source'),
    type: "PERCENTAGE",
    sort: 2,
    tooltip: {
      title: t('Triangulation'),
      body: t('Share of compliance checks for which multiple sources of information contribute to determination'),
    },
  }),
  resolved: (t) => ({
    title: t('Resolved Challenges'),
    content: t('Since subject identification'),
    type: 'DEFAULT',
    tooltip: {
      title: t('Resolved Challenges'),
      body: t('Number of counterparty challenges resolved since the subject was first identified in Datastake'),
    },
    sort: 3,
  }),
  determination: (t) => ({
    title: t('Determination'),
    content: t('Completed checks'),
    type: "PERCENTAGE",
    tooltip: {
      title: t('Determination'),
      body: t('Share of compliance checks for which the necessary information is available'),
    },
    sort: 4,
  }),
  consensus: (t) => ({
    title: t('Consensus'),
    content: t('Verified outcomes'),
    type: "PERCENTAGE",
    sort: 5,
    tooltip: {
      title: t('Consensus'),
      body: t('Share of compliance checks for which determination outcome is confirmed all available information sources'),
    },
  }),
  active: (t) => ({
    title: t('Active Challenges'),
    content: t('Latest update'),
    type: 'ACTIVE_CHALLENGES',
    tooltip: {
      title: t('Active Challenges'),
      body: t('Number of open counterparty challenges based on available information'),
    },
    sort: 6,
  }),
};

const InfoWidget = ({
  confignKey,
  value,
  t = (s) => s,
  loading,
}) => {
  const conf = useMemo(() => config[confignKey] ? config[confignKey](t) : undefined, [confignKey, t]);
  const renderedValue = useMemo(() => {
    if (conf) {
      const { type } = conf;
      switch (type) {
        case 'PERCENTAGE':
          return `${Number(value || 0).toFixed(1)}%`
        case 'CHALLENGES':
          return Number(value).toLocaleString('en-us');
        default:
          return value;
      }
    }
    return null
  }, [conf, value]);

  if (!conf) {
    return null;
  }

  return (
    <DetailsWidget
      hasActions={false}
      label={conf.title}
      loading={loading}
      tooltip={conf.tooltip}
      value={renderedValue}
      link="#sca-table-components"
    />
  )
}

export default InfoWidget;

/*
    <Style className={className}>
      <div className="main">
        <h1>{conf.title}</h1>
        <p>{conf.content}</p>
      </div>
      <div className="value">
        {renderedValue}
      </div>
    </Style>
*/